import { Link } from "react-router";
import pck from '../../package.json';

function Home() {
  const {version} = pck;
  return (
    <div className="page">
      <h1>Eric’s Photo App!</h1>
      <p>
        This app is under development. The current version is {version}. This
        is very much a pre-release intended to experiment with the intended
        functionality.
      </p>
      <p>
        The first functionality I am working on is the display of the photo
        archive, most recent photos first. Go and take a look at
        the <Link to="latest">current try</Link> for this functionality.
      </p>
    </div>
  );
}

export default Home;
